import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "@app/core/services/auth-guard";
import { RoleTypes } from "core-kit";
import { LandingGuard } from "./core/services/landing.guard";
import { LayoutComponent } from "./layouts/layout.component";

const routes: Routes = [
  { path: "home", loadComponent: () => import("./home/home.component").then((m) => m.HomeComponent), canActivate: [LandingGuard] },
  { path: "account", loadChildren: () => import("./account/account.module").then((m) => m.AccountModule) },
  { path: "callback", loadComponent: () => import("./account/callback.component").then((m) => m.CallbackComponent) },
  {
    path: "template",
    loadChildren: () => import("./template/template.module").then((m) => m.TemplateModule),
    canActivate: [AuthGuard],
    data: { roles: [RoleTypes.Admin, RoleTypes.PartnerAdmin, RoleTypes.Manager, RoleTypes.LocationManager] }
  },
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () => import("./pages/pages.module").then((m) => m.PagesModule)
  },
  { path: "**", redirectTo: "" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
